import { useState, useEffect, useCallback } from 'react';
import { useCooperativeId } from 'hooks';
import { SortParams, BaseMassMessage, SortParamsArg } from 'models';
import { eventInformationTableCells } from 'configs';
import services from 'services';

import { Table } from 'components';

interface EventInformationTableState {
  massMessages: BaseMassMessage[];
  sortParams: SortParams;
  loading: boolean;
  error: boolean;
}

interface Props {
  eventId: string | null;
}

const EventInformationTable: React.FC<Props> = ({ eventId }) => {
  const coopId = useCooperativeId();

  const [state, setState] = useState<EventInformationTableState>({
    massMessages: [],
    loading: true,
    error: false,
    sortParams: {
      order: 'asc',
      orderBy: 'Subject',
      type: 'string',
    },
  });

  useEffect(() => {
    let mounted = true;

    if (coopId && eventId) {
      (async function () {
        try {
          const massMessages: BaseMassMessage[] = (
            await services.get(
              `/api/user/cooperatives/${coopId}/events-information/${eventId}/mass-messages`
            )
          ).data.Data;

          if (mounted) {
            setState((prevState) => ({
              ...prevState,
              loading: false,
              massMessages,
            }));
          }
        } catch (err) {
          console.error(err);
          if (mounted) {
            setState((prevState) => ({
              ...prevState,
              massMessages: [],
              loading: true,
              error: false,
            }));
          }
        }
      })();
    }

    return () => {
      mounted = false;
    };
  }, [eventId, coopId]);

  const handleChangeSortParams = useCallback((params: SortParamsArg) => {
    setState((prevState) => ({
      ...prevState,
      sortParams: {
        order: prevState.sortParams.order === 'desc' ? 'asc' : 'desc',
        orderBy: params.id,
        type: params.type,
      },
    }));
  }, []);

  return (
    <Table
      order={state.sortParams.order}
      orderBy={state.sortParams.orderBy}
      list={state.massMessages}
      loading={state.loading}
      tableCells={eventInformationTableCells}
      handleChangeSortParams={handleChangeSortParams}
    />
  );
};

export default EventInformationTable;
